// import React, { useState } from 'react';
// import solidbackgroundimg from "../assets/solidbackgroundimg.png";
// let resolution = window.RESOLUTION;
// if(window.innerWidth >= 1920 && window.innerHeight >= 1080){resolution = "FHD";}else{resolution = "HD";}
// const userAgent = navigator.userAgent.toLowerCase();
// if (userAgent.includes('webos') || userAgent.includes('lg') || userAgent.includes('web0s')) {
// resolution = 'FHD';
// }
// const PrivacyPolicy = ({data, HandleDownBTN, HandleUpBTN}) => {
//     const [privacyPolicy] = useState(data);
//     const styles = {
//         PrivacyPolicyContainer: {
//           background: `url(${solidbackgroundimg})`,
//           display: 'flex',
//           flexDirection: 'column',
//           // background: 'transparent'  ,
//           width: '92vw',
//           height: '74vh',
//           backgroundSize: 'cover',
//           backgroundPosition: 'center', // Center the background image
//           backgroundRepeat: 'no-repeat', // Do not repeat the background image
//           color: '#D0D0D0',
//           fontSize: '18px',
//           overflow:'scroll',
//         },
//       };
//   return (
//     <div style={styles.PrivacyPolicyContainer} dangerouslySetInnerHTML={{ __html: privacyPolicy }}/>

//   );
// };
// export default PrivacyPolicy;

import React, { useEffect, useRef, useState } from "react";
import solidbackgroundimg from "../assets/solidbackgroundimg.png";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";
import LoaderScreen from "./LoaderScreen";

let resolution = window.RESOLUTION;

const PrivacyPolicy = ({ data, HandleDownBTN, HandleUpBTN, shouldCloseMenu }) => {
  const [privacyPolicy] = useState(data);
  const containerRef = useRef(null);
  const [hasSentEvent, setHasSentEvent] = useState(false);

  useEffect(() => {
    if(!hasSentEvent){
      // Matomo Event
      sendTestMatomoEvent({ eventCategory:"Page", eventAction:"View", eventName:"Privacy Policy", url: "privacy-policy" });
      setHasSentEvent(true);
    }
   
  }, []);

  const [focusState, setFocusState] = useState({
    focusOnText: false, // Focus on text content
    shouldFocusToRowList: true, // Focus on row list
    loading: true,
  });

  const { focusOnText, shouldFocusToRowList, loading } = focusState;

  const customScrollbarStyles = `
    .custom-scrollbar::-webkit-scrollbar {
      width: 8px;
    }
    
    .custom-scrollbar::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 10px;
    }
    
    .custom-scrollbar::-webkit-scrollbar-thumb {
      background-color: #888;
      border-radius: 10px;
      border: 2px solid transparent;
      background-clip: content-box;
    }
    
    .custom-scrollbar::-webkit-scrollbar-thumb:hover {
      background-color: #555;
    }

    /* Firefox ke liye styles */
    .custom-scrollbar {
      scrollbar-width: thin;
      scrollbar-color: #888 rgba(0, 0, 0, 0.2);
    }
  `;

  const styles = {
    PrivacyPolicyContainer: {
      backgroundImage: `url(${solidbackgroundimg})`,
      display: "flex",
      flexDirection: "column",
      background: "#000037",
      width: "92vw",
      height: "74vh",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      color: "#D0D0D0",
      fontSize: "18px",
      overflowY: "auto", // <-- Enable vertical scroll
      overflowX: "hidden",// Allows scrolaling
      outline: "none",
      paddingRight: "15px"
    },
  };

  const handleKeyDown = (event) => {
    console.log("Key pressed:", event.code);

    if (event.code === "ArrowDown") {
      HandleDownBTN();
      setFocusState((prevState) => ({
        ...prevState,
        shouldFocusToRowList: false,
        focusOnText: true,
      }));
      if (containerRef.current) {
        containerRef.current.focus();
      }
    } else if (event.code === "ArrowUp" && focusState.focusOnText) {
      const scrollTop = containerRef.current?.scrollTop || 0;
      console.log("scrollTop:", scrollTop);
      if (scrollTop === 0) {
        window.removeEventListener("keydown", handleKeyDown);
        console.log("Reached top, shifting focus.");
        containerRef.current.blur();
        HandleUpBTN();
        setFocusState({ shouldFocusToRowList: true, focusOnText: false });
      }
    }
  };
  useEffect(() => {
    if(shouldCloseMenu){
     window.addEventListener("keydown", handleKeyDown);
    }

    setFocusState((prevState) => ({
      ...prevState,
      loading: false,
    }));

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [focusState, shouldCloseMenu]);

  return (
    <div>
      <style>{customScrollbarStyles}</style>
      {loading && <LoaderScreen />}
      <div
        ref={containerRef}
        className="custom-scrollbar"
        style={{
          ...styles.PrivacyPolicyContainer,
          border: "none", // Highlight focus on text content
        }}
        tabIndex={focusState.focusOnText ? -1 : 0} // Focus management
        dangerouslySetInnerHTML={{ __html: privacyPolicy }} // Render the Privacy Policy text
      />
    </div>
  );
};

export default PrivacyPolicy;
